import React from 'react';
import PaymentRealizedMade from 'components/Tvendo/Bank/DataMaster/Payments/PaymentRealizedMade.js';

export default function () {
  return <PaymentRealizedMade />;
}
